import React, { Component } from "react";
import GravityForm from "react-gravity-form";
import TextareaAutosize from 'react-textarea-autosize';

export default class PageContact extends Component {
  	
  	constructor(){
		super()
		this.state = {
			open: 		false,
			maxHeight: 0,
			selected: 'Please Select',
			submitted: false
		}
		this.handleToggle 	= this.handleToggle.bind(this);
		this.handleSubmit 	= this.handleSubmit.bind(this);
		this.submitSuccess 	= this.submitSuccess.bind(this);
	}
    
    handleToggle(_evt) {
	    _evt.preventDefault();
	    document.documentElement.classList.remove('state-popup-open');
    }
    
    handleSubmit(_evt) {
		_evt.preventDefault();
		let val = document.getElementsByClassName('faux-text-box')[0].getElementsByTagName('textarea')[0].value;
		document.getElementsByClassName('scope-form--project-enq')[0].getElementsByTagName('textarea')[0].value = val;
		document.getElementsByClassName('scope-form--project-enq')[0].getElementsByTagName('textarea')[0].dispatchEvent(new Event('blur'));
		setTimeout(function(){
			document.getElementsByClassName('scope-form--project-enq')[0].getElementsByClassName('footer')[0].getElementsByTagName('button')[0].click();
		}, 10);
    }
    
    submitSuccess() {
	    //this.setState({ submitted : true });
		window.location = window.location.origin + '/project-thank-you';
    }
  	
	render () {
		
		let post = this.props.post;
				
		if (post) {
									
		    return (
			    
			    <div className="c-popup">
						
					<a href="#" className="c-popup__overlay" onClick={this.handleToggle}></a>
					
					<div className="c-popup__panel">
					
						<div className="c-popup__panel__inner">
			    			
			    			<div className="scope-centered-text" dangerouslySetInnerHTML={{__html:'<h2>Enquire</h2>'}}></div>
		    		    			
			    			<div className="scope-form scope-form--project-enq">
			    					    				
			    				<GravityForm
									backendUrl={document.location.origin + '/wp-json/sivasli/v1/form'}
									formID={3}
									populatedFields={{project: post.heading + ' – ' + post.suburb}}
									onSubmitSuccess={this.submitSuccess}
								/>
								
								<div className="faux-text-box">
									<TextareaAutosize placeholder="Message..." />
								</div>
								
								<a href="#" className="faux-submit" onClick={this.handleSubmit} dangerouslySetInnerHTML={ {__html: 'Submit'}}></a>
								
								<div className="success-message scope-centered-text" dangerouslySetInnerHTML={{__html: '<p>Thanks for your enquiry. We will contact you shortly.</p>'}}></div>
														
			    			</div>
						</div>
					</div>
				</div>
					
			)
			
		} else {
			
			return null;
		
		}
	}
}
